import axiosInstance from "./axiosInstance";
import getStoredUserInfo from "../helpers/getUserInfo";

const getUserProfile = async () => {
  const userInfo = getStoredUserInfo();
  const accessToken = userInfo?.token;

  try {
    const {data} = await axiosInstance.get(`/getUserProfile`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return data;
  } catch (error) {
    return null;
  }
};

export default getUserProfile;
